import React, { ReactNode } from 'react';
import { I18n, hasTranslation } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Link, Text } from '@fiverr-private/typography';

export interface AnswerProps {
    answerKey: string;
    links?: Record<string, string>;
}

const getParagraphKeys = (answerKey: string) => {
    const paragraphKeys: string[] = [];

    while (hasTranslation(`${answerKey}.p${paragraphKeys.length + 1}`)) {
        paragraphKeys.push(`p${paragraphKeys.length + 1}`);
    }

    return paragraphKeys;
};

const buildLinkTemplates = (links: AnswerProps['links']) =>
    Object.entries(links || {}).reduce(
        (templates, [name, href]) => ({
            ...templates,
            [name]: (text: ReactNode) => <Link href={href}>{text}</Link>,
        }),
        {}
    );

const Answer = ({ answerKey, links }: AnswerProps) => {
    const templates = buildLinkTemplates(links);

    return (
        <Stack direction="column" gap="4">
            {getParagraphKeys(answerKey).map((paragraphKey) => (
                <Text key={paragraphKey} color="bodySecondary">
                    <I18n k={`${answerKey}.${paragraphKey}`} templates={templates} />
                </Text>
            ))}
        </Stack>
    );
};

export { Answer };
export default Answer;
